export class PetToInvoiceModel {
    pet_no: number
    pet_name: string
    index: number
    checkRabies: boolean
    ToBeInvoiced: boolean
    amount: number
    TaxAmt: number
    currentBalance: number

    constructor(
        pet_no: number,
        pet_name: string,
        index: number,
        checkRabies: boolean,
        ToBeInvoiced: boolean,
        amount: number,
        TaxAmt: number,
        currentBalance: number
    ) {
        this.pet_no = pet_no
        this.pet_name = pet_name
        this.index = index
        this.checkRabies = checkRabies
        this.ToBeInvoiced = ToBeInvoiced
        this.amount = amount
        this.TaxAmt = TaxAmt
        this.currentBalance = currentBalance
    }
}


export class PaymentDetailsModel {
    pet_no: number
    actual_charge: number
    total_charge: number
    Discount: number
    total_tax: number
    prior_balance: number
    balance_due: number
    amount_paid: number
    coupon: number
    clinic_account: number
    change: number
    current_balance: number
    deposit: number
    ownership:number

    constructor(
        pet_no: number,
        actual_charge: number,
        total_charge: number,
        Discount: number,
        total_tax: number,
        prior_balance: number,
        balance_due: number,
        amount_paid: number,
        coupon: number,
        clinic_account: number,
        change: number,
        current_balance: number,
        deposit: number,
        ownership: number,
    ) {
        this.pet_no = pet_no
        this.actual_charge = actual_charge
        this.total_charge = total_charge
        this.Discount = Discount
        this.total_tax = total_tax
        this.prior_balance = prior_balance
        this.balance_due = balance_due
        this.amount_paid = amount_paid
        this.coupon = coupon
        this.clinic_account = clinic_account
        this.change = change
        this.current_balance = current_balance
        this.deposit = deposit
        this.ownership = ownership
    }
}


export class TempPrescModel {
    transact_sequence: number
    pet_no: number
    presc_date: string
    product_name: string
    doctor: string
    units: number
    package: string
    refill_count: number
    refill_expire: string
    allow_generic: boolean
    instructions: string
    in_clinic: boolean
    use_for: string

    constructor(
        transact_sequence: number,
        pet_no: number,
        presc_date: string,
        product_name: string,
        doctor: string,
        units: number,
        ipackage: string,
        refill_count: number,
        refill_expire: string,
        allow_generic: boolean,
        instructions: string,
        in_clinic: boolean,
        use_for: string
    ) {
        this.transact_sequence = transact_sequence
        this.pet_no = pet_no
        this.presc_date = presc_date
        this.product_name = product_name
        this.doctor = doctor
        this.units = units
        this.package = ipackage
        this.refill_count = refill_count
        this.refill_expire = refill_expire
        this.allow_generic = allow_generic
        this.instructions = instructions
        this.in_clinic = in_clinic
        this.use_for = use_for
    }
}



